import { render } from "./infobar.vue?vue&type=template&id=51d1a0c1"
import script from "./infobar.vue?vue&type=script&lang=js"
export * from "./infobar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/ORM_CRENT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__